// extracted by mini-css-extract-plugin
export default {"main":"BaZi7YqZitVg9b9t+CTNKg=="};